<div *ngIf="report" class="report-item {{report.IsAdminOnly ? 'admin' : ''}}">
    <div class="report-header">{{report.DisplayName}}</div>
    <div class="{{isLoading ? 'disabled-btn' : 'download-btn'}}"
        (click)="isLoading ? null : reportSelected.emit(report)">
        <mat-icon>download</mat-icon>
        DOWNLOAD
    </div>
</div>